(function () {
  'use strict';

  function findSectionTarget(target) {
    var normalized = (target || '').replace(/^#/, '');
    if (!normalized) return null;

    var exact = document.getElementById(normalized);
    if (exact) return exact;

    var candidates = [];
    if (normalized.indexOf('main-collection') !== -1) {
      candidates = [
        '[id*="main-collection"]',
        '[data-section-type*="collection"]',
        '.shopify-section[id*="__main"]'
      ];
    } else if (normalized.indexOf('faq') !== -1 || normalized.indexOf('accordion') !== -1) {
      candidates = [
        '[id*="faq"]',
        '[id*="accordion"]',
        '.shopify-section:has(details)'
      ];
    }

    for (var i = 0; i < candidates.length; i += 1) {
      var fallback = document.querySelector(candidates[i]);
      if (fallback) return fallback;
    }

    return null;
  }

  function initNavigation(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var wrapper = root.closest('.shopify-section') || root.parentElement;
    var shouldStick = root.dataset.refurbishedNavSticky !== 'false';
    var cartCount = root.querySelector('[data-refurbished-cart-count]');
    var scrollFrame = null;

    function renderCartCount(count) {
      if (!cartCount || !Number.isFinite(Number(count))) return;

      var itemCount = Math.max(0, Number(count));
      cartCount.textContent = itemCount > 99 ? '99+' : String(itemCount);
      cartCount.hidden = itemCount === 0;
    }

    function handleCartChange(event) {
      var changedCart = event.detail && event.detail.cart;
      if (changedCart && typeof changedCart.item_count !== 'undefined') {
        renderCartCount(changedCart.item_count);
      }
    }

    function updateNavigationHeight() {
      if (!wrapper) return;
      wrapper.style.setProperty('--refurbished-nav-height', root.offsetHeight + 'px');
    }

    function updateFixedState() {
      scrollFrame = null;
      if (!wrapper || !shouldStick) return;

      var fixed = wrapper.getBoundingClientRect().top <= 0;
      root.classList.toggle('is-fixed', fixed);
      root.setAttribute('aria-label', fixed ? 'Refurbished navigation, fixed' : 'Refurbished navigation');
      document.documentElement.classList.toggle('lefeet-refurbished-nav-is-fixed', fixed);
    }

    function requestFixedStateUpdate() {
      if (scrollFrame !== null) return;
      scrollFrame = window.requestAnimationFrame(updateFixedState);
    }

    updateNavigationHeight();
    updateFixedState();
    window.addEventListener('scroll', requestFixedStateUpdate, { passive: true });
    window.addEventListener('resize', function () {
      updateNavigationHeight();
      requestFixedStateUpdate();
    });
    document.addEventListener('cart:change', handleCartChange);

    root.querySelectorAll('[data-refurbished-nav-link]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = findSectionTarget(link.dataset.anchorTarget);
        if (!target) return;

        event.preventDefault();
        var offset = root.getBoundingClientRect().height + 16;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    });
  }

  function initBenefits(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var viewport = root.querySelector('[data-refurbished-benefits-viewport]');
    var track = root.querySelector('[data-refurbished-benefits-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-refurbished-benefit-slide]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-refurbished-benefit-tab]'));
    var tabsWrap = root.querySelector('.lefeet-refurbished-benefits__tabs-wrap');
    var descriptions = Array.prototype.slice.call(root.querySelectorAll('[data-refurbished-benefit-description]'));
    var progressBars = Array.prototype.slice.call(root.querySelectorAll('[data-refurbished-benefit-progress]'));
    var previous = root.querySelector('[data-refurbished-benefits-prev]');
    var next = root.querySelector('[data-refurbished-benefits-next]');
    var current = 0;
    var pointerStart = null;
    var autoplayTimer = null;
    var autoplayDelay = 5000;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!track || slides.length < 1) return;

    function restartProgress() {
      progressBars.forEach(function (bar) {
        bar.classList.remove('is-running');
      });

      if (!progressBars[current]) return;
      void progressBars[current].offsetWidth;
      progressBars[current].classList.add('is-running');
    }

    function scheduleAutoplay() {
      window.clearTimeout(autoplayTimer);
      if (slides.length < 2 || reducedMotion.matches || document.hidden) return;

      autoplayTimer = window.setTimeout(function () {
        render(current + 1, true, true);
      }, autoplayDelay);
    }

    function positionArrows(slideWidth, gap) {
      if (!viewport) return;

      var trackStyle = getComputedStyle(track);
      var activeLeft = parseFloat(trackStyle.paddingLeft) || 0;
      var viewportWidth = viewport.getBoundingClientRect().width;

      function setArrowPosition(arrow, center) {
        if (!arrow) return;
        var arrowWidth = arrow.getBoundingClientRect().width || 48;
        var left = center - (arrowWidth / 2);
        left = Math.max(0, Math.min(left, viewportWidth - arrowWidth));
        arrow.style.left = left + 'px';
        arrow.style.right = 'auto';
      }

      setArrowPosition(previous, activeLeft - (gap / 2));
      setArrowPosition(next, activeLeft + slideWidth + (gap / 2));
    }

    function revealActiveTab(tab, animate) {
      if (!tabsWrap || !tab || tabsWrap.scrollWidth <= tabsWrap.clientWidth) return;

      var wrapRect = tabsWrap.getBoundingClientRect();
      var tabRect = tab.getBoundingClientRect();
      var edgePadding = 24;
      var nextScrollLeft = tabsWrap.scrollLeft;

      if (tabRect.left < wrapRect.left + edgePadding) {
        nextScrollLeft -= (wrapRect.left + edgePadding) - tabRect.left;
      } else if (tabRect.right > wrapRect.right - edgePadding) {
        nextScrollLeft += tabRect.right - (wrapRect.right - edgePadding);
      } else {
        return;
      }

      tabsWrap.scrollTo({
        left: Math.max(0, nextScrollLeft),
        behavior: animate && !reducedMotion.matches ? 'smooth' : 'auto'
      });
    }

    function render(index, animate, restartAutoplay) {
      current = (index + slides.length) % slides.length;
      var slideWidth = slides[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
      track.style.transition = animate ? '' : 'none';
      track.style.transform = 'translate3d(' + (-current * (slideWidth + gap)) + 'px, 0, 0)';
      positionArrows(slideWidth, gap);

      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      tabs.forEach(function (tab, tabIndex) {
        var active = tabIndex === current;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      revealActiveTab(tabs[current], animate);

      descriptions.forEach(function (description, descriptionIndex) {
        description.hidden = descriptionIndex !== current;
        description.classList.toggle('is-active', descriptionIndex === current);
      });

      if (previous) previous.hidden = current === 0;
      if (next) next.hidden = current === slides.length - 1;

      if (restartAutoplay !== false) {
        restartProgress();
        scheduleAutoplay();
      }
    }

    root.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-refurbished-benefit-tab]');
      if (!tab || !root.contains(tab)) return;
      event.preventDefault();
      var tabIndex = Number(tab.dataset.index);
      if (!Number.isNaN(tabIndex)) render(tabIndex, true, true);
    });

    if (previous) previous.addEventListener('click', function () { render(current - 1, true, true); });
    if (next) next.addEventListener('click', function () { render(current + 1, true, true); });

    track.addEventListener('pointerdown', function (event) {
      if (event.target.closest('button, a, input, select, textarea')) return;
      pointerStart = event.clientX;
    });

    track.addEventListener('pointerup', function (event) {
      if (pointerStart === null) return;
      var delta = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(delta) < 40) return;
      render(current + (delta < 0 ? 1 : -1), true, true);
    });

    track.addEventListener('pointercancel', function () {
      pointerStart = null;
    });

    root.addEventListener('keydown', function (event) {
      if (!event.target.closest('[data-refurbished-benefit-tab]')) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      event.preventDefault();
      var direction = event.key === 'ArrowRight' ? 1 : -1;
      render(current + direction, true, true);
      if (tabs[current]) tabs[current].focus();
    });

    window.addEventListener('resize', function () { render(current, false, false); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        window.clearTimeout(autoplayTimer);
      } else {
        restartProgress();
        scheduleAutoplay();
      }
    });

    render(0, false, true);
  }

  function initProductCarousel(carousel) {
    if (!carousel || carousel.dataset.carouselInitialized === 'true') return;
    carousel.dataset.carouselInitialized = 'true';

    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-refurbished-product-slide]'));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-refurbished-product-dot]'));
    var progressBars = Array.prototype.slice.call(carousel.querySelectorAll('[data-refurbished-product-progress]'));
    var previous = carousel.querySelector('[data-refurbished-product-prev]');
    var next = carousel.querySelector('[data-refurbished-product-next]');
    var autoplay = carousel.dataset.autoplay !== 'false';
    var autoplayDelay = parseInt(carousel.dataset.autoplayDelay, 10) || 3000;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var autoplayTimer = null;
    var pointerStart = null;
    var current = 0;

    if (slides.length < 1) return;
    carousel.style.setProperty('--refurbished-product-autoplay', autoplayDelay + 'ms');

    function restartProgress() {
      progressBars.forEach(function (progress) {
        progress.classList.remove('is-running');
      });

      if (!progressBars[current]) return;
      void progressBars[current].offsetWidth;
      progressBars[current].classList.add('is-running');
    }

    function scheduleAutoplay() {
      window.clearTimeout(autoplayTimer);
      if (!autoplay || slides.length < 2 || reducedMotion.matches || document.hidden) return;

      autoplayTimer = window.setTimeout(function () {
        render(current + 1, true);
      }, autoplayDelay);
    }

    function render(index, restartAutoplay) {
      current = (index + slides.length) % slides.length;

      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        dot.classList.toggle('is-complete', dotIndex < current);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (restartAutoplay !== false) {
        restartProgress();
        scheduleAutoplay();
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = Number(dot.dataset.index);
        if (!Number.isNaN(index)) render(index, true);
      });
    });

    if (previous) previous.addEventListener('click', function () { render(current - 1, true); });
    if (next) next.addEventListener('click', function () { render(current + 1, true); });

    carousel.addEventListener('pointerdown', function (event) {
      if (event.target.closest('button, a')) return;
      pointerStart = event.clientX;
    });

    carousel.addEventListener('pointerup', function (event) {
      if (pointerStart === null) return;
      var delta = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(delta) < 40) return;
      render(current + (delta < 0 ? 1 : -1), true);
    });

    carousel.addEventListener('pointercancel', function () {
      pointerStart = null;
    });

    carousel.addEventListener('keydown', function (event) {
      if (!event.target.closest('[data-refurbished-product-dot]')) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

      event.preventDefault();
      render(current + (event.key === 'ArrowRight' ? 1 : -1), true);
      if (dots[current]) dots[current].focus();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        window.clearTimeout(autoplayTimer);
      } else {
        restartProgress();
        scheduleAutoplay();
      }
    });

    render(0, true);
  }

  function initFeaturedProducts(root) {
    if (!root) return;
    root.querySelectorAll('[data-refurbished-product-carousel]').forEach(initProductCarousel);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-refurbished-nav]').forEach(initNavigation);
    (scope || document).querySelectorAll('[data-refurbished-benefits]').forEach(initBenefits);
    (scope || document).querySelectorAll('[data-refurbished-featured-products]').forEach(initFeaturedProducts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();